export const ValueMixin = {
	props: {
		value: {},
	},
	watch: {
		value(val) {
			this.lv_watchValue && val !== this.currentValue && (this.currentValue = val)
		},
		currentValue(val) {
			this.lv_watchCurrentValue && this.$emit('input', val)
		},
	},
	data() {
		return {
			currentValue: this.value,
			lv_watchValue: true,
			lv_watchCurrentValue: true,
		}
	},
}


export const NewValueMixin = {
	props: {
		value: {},
	},
	watch: {
		value(val) {
			this.p_watchValue && val !== this.p_value && (this.p_value = val)
		},
	},
	data() {
		return {
			p_value: this.value,
			p_watchValue: true,
		}
	},
	methods: {
		p_emitValue() {
			this.$emit('input', this.p_value)
		},
	},
}

export const MountedMixin = {
	data() {
		return {
			lv_mounted: false
		}
	},
	mounted() {
		this.lv_mounted = true
		this.$emit('mounted', this)
	},
	beforeDestroy() {
		this.lv_mounted = false
		this.$emit('beforeDestroy', this)
	},
}

export const EditMixin = {
	props: {
		readonly: {type: Boolean, default: null},
		disabled: {type: Boolean, default: null},
	},
	watch: {
		readonly(val) {
			this.lv_readonly !== val && (this.lv_readonly = val)
		},
		disabled(val) {
			if (this.$lv.$utils.typeOf(val) === 'function') {
				val = val()
			}
			this.lv_disabled !== val && (this.lv_disabled = val)
		},
		lv_readonly(val) {
			this.$emit('update:readonly', val)
		},
		lv_disabled(val) {
			this.$emit('update:disabled', val)
		},
	},
	data() {

		let disabled = this.disabled;
		if (this.$lv.$utils.typeOf(this.disabled) === 'function') {
			disabled = disabled()
		}

		return {
			lv_editCtrl: true,
			lv_readonly: Boolean(this.readonly),
			lv_disabled: Boolean(disabled),
		}
	},
	methods: {
		setReadonly(val = true) {
			this.readonly === null && (this.lv_readonly = val)
		},
		setDisabled(val = true) {
			this.disabled === null && (this.lv_disabled = val)
		},
		resetReadonly() {
			this.lv_readonly = this.readonly
		},
		resetDisabled() {
			this.lv_disabled = this.disabled
		},

	}
}
